export default __webpack_public_path__ + "static/media/cafe_2.d828f554.jpg";